// extracted by mini-css-extract-plugin
export var fileExt = "_sj-8";
export var fileIcon = "_sj-6";
export var fileLink = "_sj-5";
export var fileName = "_sj-7";
export var image = "_sj-1";
export var imageError = "_sj-3";
export var imageErrorIcon = "_sj-4";
export var imageLink = "_sj-0";
export var imageLoaded = "_sj-2";